import Display from "./Display.component";

export default Display;
